import { PoleTypeState } from './types';

const state = (): PoleTypeState => {
  return {
    poleTypes: [],
  };
};

export default state;
